// src/contexts/TranslationContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { storageManager } from '../utils/storageManager';

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
    const [selectedTranslations, setSelectedTranslations] = useState(() => {
        const storedTranslations = storageManager.getItem("selectedTranslations") || ["gujarati"];
        return Array.isArray(storedTranslations) ? storedTranslations : ["gujarati"];
    });

    useEffect(() => {
        // Allow empty selection - users can unselect all translations
        storageManager.setItem("selectedTranslations", selectedTranslations);
    }, [selectedTranslations]);

    return (
        <TranslationContext.Provider value={{ selectedTranslations, setSelectedTranslations }}>
            {children}
        </TranslationContext.Provider>
    );
};

export const useTranslation = () => {
    return useContext(TranslationContext);
};
